import styled from 'styled-components'
import { Input } from 'antd'

export const TextArea = styled(Input.TextArea)`
  border-radius: 0.5rem;
`
